module.exports = {
  apiKey: "AIzaSyBm1E-oYdKwJhxjnQ8zVmqYKANwag9GcYk",
  authDomain: "xtasy-e4d24.firebaseapp.com",
  projectId: "xtasy-e4d24",
  storageBucket: "xtasy-e4d24.appspot.com",
  messagingSenderId: "37285588184",
  appId: "1:37285588184:web:181906abac435983693bad",
  measurementId: "G-2P6830D8WG",
};
